import { useNavigate } from "react-router-dom";
import {
  CheckCircleOutlined,
} from "@ant-design/icons";
import {
  Card,
  Button,
  Space,
  Tag,
  Typography
} from "antd"

const { Title, Paragraph } = Typography
export default function  Confirmation ({startOver, goals}) {
    const navigate = useNavigate();
    return (
    <Card style={{ textAlign: "center", padding: 40 }}>
      <CheckCircleOutlined style={{ fontSize: 64, color: "#52c41a", marginBottom: 24 }} />
      <Title level={2}>Goals Successfully Set!</Title>
      <Paragraph style={{ fontSize: 16, color: "#666", marginBottom: 32 }}>
        Radar+ will now track your strategic objectives and surface the most relevant risks and opportunities to help
        you stay aligned.
      </Paragraph>

      <div style={{ marginBottom: 32 }}>
        <Title level={4}>Your Goals Summary:</Title>
        {goals.map((goal) => (
          <Tag key={goal.id} color="blue" style={{ margin: 4, padding: "4px 8px" }}>
            {goal.type}: {goal.description.substring(0, 50)}...
          </Tag>
        ))}
      </div>

      <Space size="large">
        <Button type="primary" size="large" onClick={() => navigate("/dashboard")}>
          Go to Dashboard
        </Button>
        <Button size="large" onClick={() => console.log("Review Settings")}>
          Review Settings
        </Button>
        <Button onClick={startOver}>Start Over</Button>
      </Space>
    </Card>
  )}